<template>
  <div class="shoppping-car-main">
    <Header ref="header"/>
    <div class="main-1200-width main-box">
      <div class="top">
        <el-steps
          :active="active"
          class="shopping_step"
          align-center
          finish-status="success"
        >
          <el-step title="订单信息确认"></el-step>
          <el-step title="收件信息补全"></el-step>
          <el-step title="开票信息补全"></el-step>
          <el-step title="等待审核"></el-step>
          <el-step title="签署合同"></el-step>
        </el-steps>
      </div>
      <div v-if="active === 0">
        <!-- S-- 表格 -->
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="商品" align="center" width="500">
            <template slot-scope="scope">
              <div class="template-goodsinfo">
                <img :src="scope.row.goods && $url.cdn(scope.row.goods.image)" alt=""/>
                <div class="goods-info">
                  <div class="line">
                    {{ scope.row.goods && scope.row.goods.title }}
                  </div>
                  <div class="line type">
                    <span v-for="item in scope.row.sku_price.goods_sku_text" :key="item">{{ item }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价(元)" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="scope.row.sku_price.price?'text-decoration: line-through;color: #999;': ''">￥{{ scope.row.sku_price.original_price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="会员价(元)" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color: #CA141D">{{ scope.row.sku_price.price ? '￥' + scope.row.sku_price.price : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            width="160"
            label="数量"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.goods_num"
                @change="handleChange(scope.row)"
                size="mini"
                :min="scope.row.sku_price.min_number"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="小计(元)"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :style="scope.row.sku_price.price?'color: #CA141D;': ''">￥{{ (scope.row.goods_num * (scope.row.sku_price.price?scope.row.sku_price.price:scope.row.sku_price.original_price)).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)"
              >删除
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- E-- 表格 -->
        <!-- S-- 统计 -->
        <div class="statistics">
          <div class="zj-top">
            <div @click="switchSelect">全选</div>
            <div @click="deletetSelectGoods">删除选中商品</div>
          </div>
          <div class="tj-main">
            <div class="tj-line">
              统计金额：
              <div>￥{{ totalPrice }}</div>
            </div>
            <div class="tj-line">
              合计（不含运费）：
              <div class="red">￥{{ totalPrice }}</div>
            </div>
          </div>
        </div>
        <!-- E-- 统计 -->
        <div class="buy-button">
          <div class="submit" @click="goodsConfirm">确认订单</div>
        </div>
      </div>
      <div v-if="active === 1" class="buy-info">
        <div class="buy-form">
          <div class="buy-form-line">
            <div class="buy-from-line-left"><span>*</span>姓名：</div>
            <div class="buy-from-line-right">
              <el-input
                v-model="addressForm.consignee"
                placeholder="请输入姓名（必填）"
                @input="change($event)"
              ></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left"><span>*</span>手机号：</div>
            <div class="buy-from-line-right">
              <el-input v-model="addressForm.mobile" placeholder="请输入手机号（必填）" @input="change($event)"></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left"><span>*</span>电子邮箱：</div>
            <div class="buy-from-line-right">
              <el-input v-model="addressForm.email" placeholder="请输入电子邮箱（必填）" @input="change($event)"></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left"><span>*</span>收件地址：</div>
            <div class="buy-from-line-right">
              <el-input v-model="addressForm.address" placeholder="请输入收件地址（必填）" @input="change($event)"></el-input>
            </div>
          </div>
        </div>
        <div class="buy-button">
          <div class="submit" @click="next">下一步</div>
        </div>
      </div>
      <div v-if="active === 2" class="buy-info">
        <div class="buy-form">
          <div class="buy-form-line">
            <div class="buy-from-line-left">类型：</div>
            <div class="buy-from-line-right">
              <el-radio-group v-model="institutionForm.type">
                <el-radio label="person">企业</el-radio>
                <el-radio label="company">高校&研究所</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left"><span>*</span> 机构名称：</div>
            <div class="buy-from-line-right">
              <el-input v-model="institutionForm.name" placeholder="请输入机构名称（必填）"></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left"><span>*</span>单位税号：</div>
            <div class="buy-from-line-right">
              <el-input v-model="institutionForm.tax_no" placeholder="请输入单位税号（必填）"></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left">开户银行：</div>
            <div class="buy-from-line-right">
              <el-input v-model="institutionForm.bank_name" placeholder="请输入开户银行（选填）"></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left">银行账号：</div>
            <div class="buy-from-line-right">
              <el-input v-model="institutionForm.bank_no" placeholder="请输入银行账号（选填）"></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left">企业地址：</div>
            <div class="buy-from-line-right">
              <el-input v-model="institutionForm.address" placeholder="请输入企业地址（选填）"></el-input>
            </div>
          </div>
          <div class="buy-form-line">
            <div class="buy-from-line-left">企业电话：</div>
            <div class="buy-from-line-right">
              <el-input v-model="institutionForm.mobile" placeholder="请输入企业电话（选填）"></el-input>
            </div>
          </div>
        </div>
        <div class="buy-button">
          <div class="submit" @click="buySubmit">信息提交</div>
        </div>
      </div>
      <div v-if="active === 3" class="buy-approval">
        <div class="approval-icon">
          <i class="el-icon-check"></i>
        </div>
        <div class="approval-title">
          您已成功提交申请
        </div>
        <div class="approval-describe">
          <p>您的申请正在审批中，待审批结束后再来操作</p>
          <p>预计审批完成时间：1个工作日左右</p>
        </div>
        <div class="buy-button">
          <a class="submit" href="/">返回首页</a>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import Header from "@/globalComponents/Header";
  import Footer from "@/globalComponents/Footer";
  import userApi from '@/api/user'
  import contractApi from '@/api/contract'
  export default {
    name      : "HelloWorld",
    components: {
      Header,
      Footer
    },
    data() {
      return {
        active           : 0,
        radio            : "1",
        msg              : "Welcome to Your Vue.js App",
        tableData        : [],
        multipleSelection: [],
        totalPrice       : 0.00,
        selectData       : [],
        addressForm      : {},
        institutionForm  : {type: 'person'},
      };
    },
    created() {
      this.getShoppingList();
      this.getAddressInfo();
      this.getInstitutionInfo();
    },
    methods   : {
      //解决有时候input无法输入的BUG
      change(e) {
        this.$forceUpdate()
      },
      // 获取收件信息
      async getAddressInfo() {
        let {data} = await userApi.address.list()
        if(data.length > 0) {
          this.addressForm = data[0]
        }
      },
      // 获取开票信息
      async getInstitutionInfo() {
        let {data} = await userApi.invoice.list()
        if(data.length > 0) {
          this.institutionForm = data[0]
        }
      },
      // 计算总金额
      calTotalPrice() {
        let data = this.$refs.multipleTable.selection;
        let Price = 0.00;
        for (let i in data) {
          Price += data[i]["goods_num"] * (data[i]["sku_price"]["price"] ? data[i]["sku_price"]["price"] : data[i]["sku_price"]["original_price"]);
        }
        this.totalPrice = Price.toFixed(2);
      },
      async handleChange(item) {
        this.calTotalPrice();
        await this.$store.dispatch('cart/update', {
          goods_id: item.goods_id,
          goods_num: item.goods_num,
          goods_sku_price_id: item.goods_sku_price_id
        })
      },
      // 获取购物车列表
      async getShoppingList() {
        await this.$store.dispatch('cart/getList')
        this.tableData = this.$store.state.cart.list;
      },
      handleSelectionChange(e) {
        this.calTotalPrice();
      },
      switchSelect() {
        this.$refs.multipleTable.toggleAllSelection();
      },
      async handleDelete(item) {
        await this.$store.dispatch('cart/delete', item.id)
        this.$message({
          message: '删除成功！',
          type   : "success"
        });
        this.$refs.header.getCartNum();
        this.getShoppingList();
      },
      goodsConfirm() {
        let goodsIds = this.$refs.multipleTable.selection;
        if (goodsIds.length > 0) {
          this.selectData = goodsIds;
          this.active++;
        } else {
          this.$message({
            message: '请选择商品！',
            type   : "error"
          });
        }
      },
      async next() {
        if (!this.addressForm.consignee ) {
          this.$message({
            message: '请填写姓名！',
            type   : "error"
          });
        } else if (!this.addressForm.mobile) {
          this.$message({
            message: '请填写手机号！',
            type   : "error"
          });
        } else if (!this.addressForm.email) {
          this.$message({
            message: '请填写邮箱！',
            type   : "error"
          });
        } else if (!this.addressForm.address) {
          this.$message({
            message: '请填写收件地址！',
            type   : "error"
          });
        } else {
          this.addressForm['is_default'] = 1
          if(this.addressForm.id) {
            await userApi.address.update(this.addressForm.id, this.addressForm)
          } else {
            let {data} = await userApi.address.create(this.addressForm)
            this.addressForm.id = data.id
          }
          this.active++;
        }
      },
      async buySubmit() {
        if (!this.institutionForm.type) {
          this.$message({
            message: '请选择类型！',
            type   : "error"
          });
          return false;
        }
        if (!this.institutionForm.name) {
          this.$message({
            message: '请填写机构名称！',
            type   : "error"
          });
          return false;
        }
        if (!this.institutionForm.tax_no) {
          this.$message({
            message: '请填写单位税号！',
            type   : "error"
          });
          return false;
        }

        //step1:提交发票信息
        if(this.institutionForm.id) {
          await userApi.invoice.update(this.institutionForm.id, this.institutionForm)
        } else {
          let {data} = await userApi.invoice.create(this.institutionForm)
          this.institutionForm.id = data.id
        }

        let data = {
          contact: {
            //收件信息
            name                : this.addressForm.consignee, //联系人姓名（参数1：必传）
            mobile              : this.addressForm.mobile,//手机号（参数2：必传）
            email               : this.addressForm.email,
            address             : this.addressForm.address, //收件地址（参数3：必传）
            //开票信息
            type                : this.institutionForm.type == 'person' ? 1 : 2, //联系信息类型：1公司（参数4：必传）
            nickname            : this.institutionForm.name,  //公司名称（参数5：必传）
            id_no               : this.institutionForm.tax_no,
            deposit_bank        : this.institutionForm.bank_name,
            bank_account        : this.institutionForm.bank_no,
            business_address    : this.institutionForm.address,
            enterprise_telephone: this.institutionForm.mobile
          }
        };
        let goods = [];
        for (let i in this.selectData) {
          let item = this.selectData[i];
          goods.push(item["id"]);
        }
        data["ids"] = goods;

        let {code} = await contractApi.order.create(data)
        if (code == 1) {
          this.active++;
        }
      },
      deletetSelectGoods() {
        let data = this.$refs.multipleTable.selection;
        for (let i in data) {
          this.handleDelete(data[i]);
        }
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/shopping-car/index.vue